module.exports = __webpack_public_path__ + "img/custom-components.f2c04ec8.svg";